import i from "clsx";
import t from "react";
import { s as r } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function p({
  size: e = "small",
  accessibilityTitle: l = "glyph hospital solid",
  className: s,
  "data-testid": H,
  fill: a,
  stroke: o
}) {
  const V = () => i(s, r["ride-glyph"], {
    [r[`size-${e}`]]: e
  });
  return /* @__PURE__ */ t.createElement("div", { className: V(), "data-testid": H }, /* @__PURE__ */ t.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: a || "#03050F",
      stroke: o || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    l && /* @__PURE__ */ t.createElement("title", null, l),
    /* @__PURE__ */ t.createElement("path", { d: "M24 11.0028H20V15.0028H18.0019V2.99902H6.00191V16.5387C5.39389 16.8893 4.88881 17.3937 4.53742 18.0012C4.18602 18.6088 4.00068 19.2981 4 20V28.0038H10.0019V23.0028H14.0019V28.0038H28V15.0143C28.0015 14.4881 27.8992 13.9667 27.6988 13.48C27.4985 12.9934 27.2041 12.5511 26.8325 12.1785C26.4609 11.8058 26.0194 11.5102 25.5334 11.3084C25.0473 11.1067 24.5263 11.0028 24 11.0028V11.0028ZM16 11.0028H13.001V14.0019H10.999V11.0028H8V9.00093H10.999V6.00189H13.001V9.00093H16V11.0028ZM25.001 23.9923H18.999V22.0019H25.0124L25.001 23.9923ZM25.001 19.9923H18.999V18.0019H25.0124L25.001 19.9923ZM25.001 15.9923H22.0019V14.0019H25.0124L25.001 15.9923Z" })
  ));
}
export {
  p as RideGlHospitalSolid
};
